module.exports = __webpack_public_path__ + "static/media/FT-Nina.14abd067.png";